"use strict";

import preload from "./modules/preload.js";
import observer from "./services/observer.js";
import showStyles from "./modules/styles.js";
import showProducts from "./modules/products.js";
import showSmallMenu from "./modules/smallMenu.js";
import showTopMenuAndArrows from "./modules/showTopMenu.js";
import hamburger from "./modules/hamburger.js";

import { stylesImg, stylesLink, modal } from "./services/variables.js";
import { setTimeout } from "core-js";

import cookies from "./modules/coockies.js";

document.addEventListener("click", (e) => {
	// Шукаємо, чи клікнули по самому щиту або по іконці всередині нього
	const btn = e.target.closest('[data-cc="show-preferences"]');

	if (btn) {
		e.preventDefault();
		showPreferences(); // Виклик вікна налаштувань
	}
});

window.addEventListener("DOMContentLoaded", () => {
	cookies();

	preload(".overlay", "body", "style");
	observer("Delay", ".animate");

	listener("click");
	listener("touchend");

	window.addEventListener("scroll", showTopMenuAndArrows);

	function listener(action) {
		window.addEventListener(action, (e) => {
			if (
				e.target.classList.contains("style__show") ||
				e.target.closest(".btn__styles")
			) {
				showStyles(
					e.target,
					".btn__styles",
					"styles__link",
					"styles__title",
					"style__show",
				);
			} else if (e.target.closest(".products")) {
				showProducts(
					"menu__full_white",
					"menu__forbigproduct",
					"show",
					"overflow_hidden",
				);
			} else if (e.target.closest(".menu__subtitle")) {
				showSmallMenu(e.target, "show", "height", "overflow_scroll");
			} else if (
				e.target.closest(".hamburger") ||
				e.target.classList.contains(".hamburger")
			) {
				hamburger(
					"menu__full_white",
					"menu__forbigproduct",
					"menu__big_show",
					"menu__list_hide",
					"menu__display_none",
					"overflow_scroll",
					"show",
					"height",
				);
			} else if (e.target.closest(".modal__close")) {
				modal.classList.remove("show__modal");
			}
		});
	}

	stylesLink.forEach((item, i) => {
		item.addEventListener("mouseover", () => {
			stylesImg[i].classList.add("show");
		});
		item.addEventListener("mouseout", () => {
			stylesImg[i].classList.remove("show");
		});
	});

	// window.addEventListener("load", () => {
	// 	setTimeout(modalShow, 1000);
	// });

	const forms = document.querySelectorAll("form");
	const modalMini = document.querySelector(".modal__mini");

	// forms.forEach((form) => {
	// 	form.addEventListener("submit", function (e) {
	// 		e.preventDefault();

	// 		fetch("mailer/smart.php", {
	// 			method: "POST",
	// 			body: new FormData(this),
	// 		})
	// 			.then(function (response) {
	// 				if (response.ok) {
	// 					form.querySelectorAll("input").forEach((input) => {
	// 						input.value = "";
	// 					});
	// 					modalWrapper.classList.remove("show");
	// 					modalMini.classList.add("show");

	// 					setTimeout(function () {
	// 						modal.classList.remove("show");
	// 						modalMini.classList.remove("show");
	// 					}, 5000);

	// 					form.reset();
	// 				}
	// 			})
	// 			.catch((error) => {
	// 				console.log("Error:", error);
	// 			});

	// 		return false;
	// 	});
	// });

	const checkbox = document.getElementById("privacy-policy");
	const submitButton = document.querySelector(".footer__form__triggers-btn");

	checkbox.addEventListener("change", function () {
		submitButton.disabled = !checkbox.checked;
	});

	forms.forEach((form) => {
		form.addEventListener("submit", function (e) {
			e.preventDefault();

			fetch("mailer/smart.php", {
				method: "POST",
				body: new FormData(this),
			})
				.then(function (response) {
					if (response.ok) {
						form.querySelectorAll("input").forEach((input) => {
							input.value = "";
						});
						modal.classList.add("show__modal");
						modalMini.classList.add("show");

						setTimeout(function () {
							modal.classList.remove("show__modal");
							modalMini.classList.remove("show");
						}, 5000);

						form.reset();
					}
				})
				.catch((error) => {
					console.log("Error:", error);
				});

			return false;
		});
	});
});
